import React from "react";
import { NavLink } from "react-router-dom";
import { LogOut, User as UserIcon } from "lucide-react";
import { cn } from "../lib/utils";

function prettyLabel(label) {
  if (!label) return "";
  return label.charAt(0) + label.slice(1).toLowerCase();
}

/** Frosted top dock for admin mobile / tablet chrome. */
export function AdminMobileTopNav({ items, onSettings, onLogout }) {
  return (
    <div
      className="mx-3 mb-1 mt-2 rounded-2xl border border-white/50 bg-[rgba(236,241,250,0.88)] px-2 py-2 shadow-none backdrop-blur-md sm:mx-4"
      data-testid="admin-mobile-top-nav"
    >
      <div className="flex items-end justify-around gap-0.5">
        {items.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "flex min-h-[52px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-1 transition-colors",
                isActive
                  ? "bg-[var(--t-accent)]/10 text-[var(--t-accent)]"
                  : "text-[var(--t-meta)]",
              )
            }
            data-testid={`mobile-${testid}`}
          >
            {({ isActive }) => (
              <>
                <Icon size={18} strokeWidth={1.4} />
                {isActive ? (
                  <span className="text-[9px] uppercase tracking-[0.12em]">
                    {prettyLabel(label)}
                  </span>
                ) : (
                  <span className="h-[11px]" aria-hidden />
                )}
              </>
            )}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onSettings}
          className="flex min-h-[52px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-1 text-[var(--t-meta)]"
          aria-label="Settings"
          data-testid="admin-profile-btn-mobile"
        >
          <UserIcon size={18} strokeWidth={1.4} />
          <span className="h-[11px]" aria-hidden />
        </button>
        <button
          type="button"
          onClick={onLogout}
          className="flex min-h-[52px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-1 text-[var(--t-meta)]"
          aria-label="Sign out"
          data-testid="admin-logout-mobile"
        >
          <LogOut size={18} strokeWidth={1.4} />
          <span className="h-[11px]" aria-hidden />
        </button>
      </div>
    </div>
  );
}
